/**
 * dragMenu.js
 *
 * dragMenu.vue 컴포넌트를 플러그인으로 등록합니다.
 *
 * @since 2018-05-10
 * @author ms1124.kim
 * @version 0.0.1
 *
 */

import Vue from 'vue'
import DragMenu from './dragMenu.vue'

export default {
  install () {
    Vue.component(DragMenu.name, DragMenu)
  }
}
